const API = "";  // same origin, proxied by nginx

async function api(path, opts = {}) {
  const token = localStorage.getItem("gpu_fabric_token");
  const headers = { "Content-Type": "application/json", ...opts.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...opts, headers });
  // 세션 만료 자동 로그아웃은 '토큰이 있던(=로그인된) 요청'에만 적용한다.
  // 로그인 요청(토큰 없음)의 401 은 '아이디/비밀번호 오류'·'비활성 계정' 메시지이므로
  // 가로채지 말고 아래 일반 에러 경로로 흘려보내 LoginPage 가 표시하게 한다.
  if (res.status === 401 && token && path !== "/api/auth/login") {
    localStorage.removeItem("gpu_fabric_token");
    localStorage.removeItem("gpu_fabric_user");
    window.location.reload();
    throw new Error("인증 만료");
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `API 오류 ${res.status}`);
  }
  return res.json();
}

export const GET = (p) => api(p);
export const POST = (p, d) => api(p, { method: "POST", body: JSON.stringify(d) });
export const PATCH = (p, d) => api(p, { method: "PATCH", body: JSON.stringify(d) });
export const DELETE = (p) => api(p, { method: "DELETE" });
